export const Card = () => ({
  styleOverrides: {
    root: {
      borderRadius: 12,
      backgroundImage: 'none'
    }
  },
  defaultProps: {
    elevation: 1
  }
});